module.exports = __webpack_public_path__ + "img/logo-hangyang.8aa14662.png";